import React from "react";

import { IconProps } from "../../types/common";

const RetryIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#BF5C0B",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    fillRule="evenodd"
    clipRule="evenodd"
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={fillColor!}
      className={fillClassName}
      d="M13.404 3.002c-5.09-.14-9.26 3.95-9.26 9h-1.79c-.45 0-.67.54-.35.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79a.5.5 0 00-.36-.85h-1.79c0-3.9 3.18-7.05 7.1-7 3.72.05 6.85 3.18 6.9 6.9.05 3.91-3.1 7.1-7 7.1-1.25 0-2.42-.34-3.44-.91a.972.972 0 00-1.18.18c-.46.46-.37 1.25.2 1.57 1.31.73 2.81 1.16 4.42 1.16 5.05 0 9.14-4.17 9-9.26-.13-4.69-4.05-8.61-8.74-8.74z"
    />
  </svg>
);

export default RetryIcon;
